import {
  Table,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Space,
  Tag,
  message,
  Popconfirm,
} from "antd";

import { useEffect, useState } from "react";
import api from "../../services/api";

export default function AdminAttributes() {
  const [attributes, setAttributes] = useState([]);
  const [openAttr, setOpenAttr] = useState(false);
  const [openValue, setOpenValue] = useState(false);

  const [editingAttr, setEditingAttr] = useState(null);
  const [selectedAttr, setSelectedAttr] = useState(null);

  const [attrForm] = Form.useForm();
  const [valueForm] = Form.useForm();

  /* LOAD */
  const loadAttributes = async () => {
    const res = await api.get("/attributes");
    setAttributes(res.data || []);
  };

  useEffect(() => {
    loadAttributes();
  }, []);

  /* CREATE / UPDATE ATTRIBUTE */
  const handleAttrSubmit = async (values) => {
    if (editingAttr) {
      await api.put(`/attributes/${editingAttr.id}`, values);
      message.success("Attribute updated");
    } else {
      await api.post("/attributes", values);
      message.success("Attribute created");
    }

    setOpenAttr(false);
    setEditingAttr(null);
    attrForm.resetFields();
    loadAttributes();
  };

  /* ADD VALUE */
  const addValue = async (values) => {
    await api.post(`/attributes/${selectedAttr.id}/values`, values);
    message.success("Value added");
    setOpenValue(false);
    valueForm.resetFields();
    loadAttributes();
  };

  /* DELETE */
  const deleteAttribute = async (id) => {
    await api.delete(`/attributes/${id}`);
    message.success("Deleted");
    loadAttributes();
  };

  const deleteValue = async (id) => {
    await api.delete(`/attribute-values/${id}`);
    message.success("Value deleted");
    loadAttributes();
  };

  /* EDIT */
  const handleEdit = (record) => {
    setEditingAttr(record);
    setOpenAttr(true);

    attrForm.setFieldsValue({
      name: record.name,
      input_type: record.input_type,
    });
  };

  /* TABLE */
  const columns = [
    {
      title: "Attribute",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "input_type",
    },
    {
      title: "Values",
      render: (_, record) => (
        <Space wrap>
          {record.AttributeValues?.map((v) => (
            <Tag
              key={v.id}
              closable
              onClose={(e) => {
                e.preventDefault();
                deleteValue(v.id);
              }}
            >
              {v.value}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button size="small" onClick={() => handleEdit(record)}>
            Edit
          </Button>

          <Button
            size="small"
            onClick={() => {
              setSelectedAttr(record);
              setOpenValue(true);
            }}
          >
            + Value
          </Button>

          <Popconfirm
            title="Delete this attribute?"
            onConfirm={() => deleteAttribute(record.id)}
          >
            <Button danger size="small">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          setEditingAttr(null);
          setOpenAttr(true);
          attrForm.resetFields();
        }}
      >
        + Add Attribute
      </Button>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={attributes}
        style={{ marginTop: 16 }}
      />

      {/* ATTRIBUTE DRAWER */}
      <Drawer
        title={editingAttr ? "Edit Attribute" : "Create Attribute"}
        open={openAttr}
        onClose={() => setOpenAttr(false)}
      >
        <Form layout="vertical" form={attrForm} onFinish={handleAttrSubmit}>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="input_type" label="Type" initialValue="select">
            <Select>
              <Select.Option value="select">Select</Select.Option>
              <Select.Option value="text">Text</Select.Option>
            </Select>
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Save
          </Button>
        </Form>
      </Drawer>

      {/* VALUE DRAWER */}
      <Drawer
        title={`Add Value → ${selectedAttr?.name}`}
        open={openValue}
        onClose={() => setOpenValue(false)}
      >
        <Form layout="vertical" form={valueForm} onFinish={addValue}>
          <Form.Item name="value" label="Value" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Save
          </Button>
        </Form>
      </Drawer>
    </>
  );
}
